import { InjectionToken } from "@angular/core";
export const AntiForgeryToken = new InjectionToken<string>('anti-forgery-token');
export const EvePortalCoreUrl = new InjectionToken<string>('eve-portal-core-url');
